import { ActionFilter } from "src/components/AuditLogFilter/ActionFilter";
import { Styled } from "./styles";
import { DateRange, FilterState } from "src/hooks/useAuditLogFilter";
import { PersonFilter } from "src/components/AuditLogFilter/PersonFilter";
import {
  CalendarDateRangePicker,
  Checkbox,
} from "@screencloud/screencloud-ui-components";
import { SyntheticEvent, useCallback } from "react";
import { FormattedMessage } from "react-intl";

interface LogFilterProps {
  handleFilterChange: (
    filterType: keyof FilterState,
  ) => (
    e: React.SyntheticEvent,
    data: { value: string | DateRange | null | boolean },
  ) => void;
  filters: FilterState;
  isPersonDropdownOpen: boolean;
  handlePersonDropdownOpen: () => void;
}

export const LogFilter = (props: LogFilterProps): JSX.Element => {
  const handleDateRangeCallback = useCallback(
    (range: { start: Date; end: Date }) => {
      // Update parent immediately when user changes the date range
      props.handleFilterChange("dateRange")(
        {} as unknown as SyntheticEvent<Element, Event>,
        {
          value: {
            start: range.start,
            end: range.end,
          } as DateRange,
        },
      );
    },
    [props.handleFilterChange],
  );

  return (
    <Styled>
      <div className="date-range-container">
        <CalendarDateRangePicker
          callback={handleDateRangeCallback}
          popoverPosition="left"
          className="date-range-picker"
        />
      </div>
      <div className="filter-container">
        <ActionFilter
          onChange={props.handleFilterChange("eventType")}
          value={props.filters.eventType}
          popoverPosition="right"
        />
        <PersonFilter
          onChange={props.handleFilterChange("userId")}
          value={props.filters.userId}
          isPersonDropdownOpen={props.isPersonDropdownOpen}
          handlePersonDropdownOpen={props.handlePersonDropdownOpen}
          popoverPosition="right"
        />
        {props.filters.userId === null && (
          <div className="system-logs-filter">
            <FormattedMessage
              id="admin.logs.system_logs"
              defaultMessage="System Logs"
            />
            <Checkbox
              className="system-logs-checkbox"
              onChange={(e, data) =>
                props.handleFilterChange("includeSystemLogs")(e, {
                  value: data.checked ?? true,
                })
              }
              checked={props.filters.includeSystemLogs}
              toggle
            />
          </div>
        )}
      </div>
    </Styled>
  );
};
